import { useParams, Link } from 'react-router-dom';
import { useCases } from '../data/content';
import FlowDiagram from '../components/FlowDiagram/FlowDiagram';
import './CasoDetail.css';

function CasoDetail() {
  const { slug } = useParams();
  const caso = useCases[slug];

  if (!caso) {
    return (
      <div className="page-hero">
        <h1>Caso não encontrado</h1>
        <Link to="/casos" className="btn btn-outline">Voltar aos casos</Link>
      </div>
    );
  }

  return (
    <div className="caso-detail-page">
      <div className="page-hero">
        <Link to="/casos" className="back-link">← Voltar aos casos</Link>
        <span className="caso-badge">{caso.area}</span>
        <h1>{caso.title}</h1>
      </div>

      <section className="section">
        <div className="container caso-content">
          <h2 className="caso-section-title">Fluxo</h2>
          <FlowDiagram steps={caso.flow} />

          <div className="caso-blocks">
            <div className="caso-block problem">
              <h3>Problema</h3>
              <ul>
                {caso.problem.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="caso-arrow-block">↓</div>

            <div className="caso-block solution">
              <h3>Solução</h3>
              <ul>
                {caso.solution.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="caso-arrow-block">↓</div>

            <div className="caso-block benefits">
              <h3>Benefícios</h3>
              <ul>
                {caso.benefits.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </div>

          <div className="caso-cta">
            <p>Quer algo assim na sua empresa?</p>
            <Link to="/diagnostico" className="btn btn-primary btn-large">
              Solicitar Diagnóstico Gratuito
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CasoDetail;
